<template>
    <div>
        <div class="absolute top-0 h-full w-full bg-gray-600 opacity-30 z-20"></div>
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>

</template>

<script>
export default {
  name: "Loader",
}
</script>